import * as React from 'react'
import { Button, Grid, SECONDARY_BUTTON, SIZE_SMALL } from '@mds/mds-reactjs-library'
import './FirmMemberLoginSection.css'
import { classes } from './ViewLayout'
import type { AuthState } from '../types/AuthState'
import { loginAsFirmMember } from '../util/loginActions'

type FirmMemberLoginSectionProps = {
  authState: AuthState
  jwt: string
}

const FirmMemberLoginSection = ({ authState, jwt }: FirmMemberLoginSectionProps): JSX.Element => (
  <>
    <Grid item span={12}>
      <div className={classes.orDivider} role="presentation">
        <span className={classes.orDividerRule} />
        <span className={classes.orDividerLabel}>OR</span>
        <span className={classes.orDividerRule} />
      </div>
    </Grid>
    <Grid item span={12}>
      <div className={classes.firmMemberButtonWrap}>
        <Button
          type="button"
          onClick={() => loginAsFirmMember({ authState, jwt })}
          className={`${classes.ctaButton} ${classes.firmMemberButton}`}
          appearance={SECONDARY_BUTTON}
          size={SIZE_SMALL}
        >
          Sign in as a Firm Member
        </Button>
      </div>
    </Grid>
  </>
)

export default FirmMemberLoginSection
